import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const token = new URLSearchParams(window.location.search).get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirm) {
            setError('Passwords do not match.');
            return;
        }

        if (newPassword.length < 6) {
            setError('Password must be at least 6 characters.');
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/password-reset/confirm/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, new_password: newPassword }),
            });
            const data = await res.json();
            if (res.ok) {
                setSuccess('Password updated. Redirecting to login...');
                setTimeout(() => navigate('/partner'), 2500);
            } else {
                setError(data.error || 'Something went wrong.');
            }
        } catch {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="min-h-screen bg-black flex items-center justify-center px-4">
                <p className="text-red-400 text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    Invalid reset link. Please request a new one.
                </p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-black flex items-center justify-center px-4">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35 }}
                className="w-full max-w-md border border-white/10 rounded-xl p-8 bg-white/[0.02]"
            >
                <h1 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Ojuju', sans-serif" }}>
                    Reset Password
                </h1>
                <p className="text-white/40 text-sm mb-8" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    Enter your new password below.
                </p>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="password"
                        placeholder="New password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        className="w-full bg-transparent border border-white/20 focus:border-[#A47F2D] rounded-lg px-4 py-3 text-white text-sm focus:outline-none transition-colors placeholder:text-white/20"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                    />
                    <input
                        type="password"
                        placeholder="Confirm new password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                        className="w-full bg-transparent border border-white/20 focus:border-[#A47F2D] rounded-lg px-4 py-3 text-white text-sm focus:outline-none transition-colors placeholder:text-white/20"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                    />

                    {error && (
                        <p className="text-red-400 text-xs" style={{ fontFamily: "'Poppins', sans-serif" }}>
                            {error}
                        </p>
                    )}
                    {success && (
                        <p className="text-[#A47F2D] text-xs" style={{ fontFamily: "'Poppins', sans-serif" }}>
                            {success}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-[#A47F2D] hover:bg-[#C9A063] disabled:opacity-50 text-black font-bold rounded-lg py-3 text-sm transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                        {loading ? 'Updating...' : 'Set New Password'}
                    </button>
                </form>
            </motion.div>
        </div>
    );
};

export default ResetPasswordPage;